import Holidays from "date-holidays";
import dayjs from "dayjs";
const hd = new Holidays('US', {
    types: [
        'public',
        'bank'
    ]
});
export const isBankHoliday = (date)=>{
    if (!dayjs(date).isValid()) {
        return false;
    }
    const holidays = hd.getHolidays(dayjs(date).year());
    return holidays.some((h)=>dayjs(h.date).isSame(dayjs(date), 'day'));
};

//# sourceMappingURL=isBankHoliday.js.map